import { auditGroupActions } from '../config/actions';

const defaultState = {
  isLoading: null,
  data: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case auditGroupActions.SCAN_GROUP_AUDIT_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        error: null
      };
    case auditGroupActions.SCAN_GROUP_AUDIT_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        error: action.error,
        history: state.history || []
      };
    case auditGroupActions.SCAN_GROUP_AUDIT:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null
      };
    case auditGroupActions.SCAN_GROUP_AUDIT_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        error: null
      };
    default:
      return state;
  }
};
